import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { ApiOperationStatus } from "../../Constant";

export default class Service {
  constructor(path, baseURL) {
    if (!baseURL) {
      baseURL = process.env.REACT_APP_NOT_SECRET_CODE ?? "/";
    }
    if (path) {
      baseURL += path;
    }
    this.service = this.axiosInstance(baseURL);
    this.service.interceptors.response.use(this.handleSuccess, this.handleError);
  }

  axiosInstance(baseURL) {
    let headers = { csrf: "token" };
    let service = axios.create({
      baseURL,
      headers: headers,
      withCredentials: true,
    });
    service.defaults.headers.common["Accept"] = "application/json;charset=UTF-8";
    service.defaults.headers.common["Content-Type"] = "application/json;charset=UTF-8";
    return service;
  }

  handleSuccess(response) {
    return response;
  }

  handleError = async (error) => {
    return Promise.reject(error);
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

  async get(path, callback) {
    const response = await trackPromise(this.service.get(path).catch((error) => {
      return error.response;
    }));
    return callback(response?.status, response?.data);
  }

  async getWithoutTracker(path, callback) {
    const response = await this.service.get(path);
    return callback(response?.status, response?.data);
  }

  async patch(path, payload, callback) {
    const response = await trackPromise(
      this.service.request({
        method: "PATCH",
        url: path,
        responseType: "json",
        data: payload,
      }).catch((error) => {
        return error.response;
      })
    );
    return callback(response?.status, response?.data);
  }

  async post(path, payload, callback) {
    const response = await trackPromise(
      this.service.request({
        method: "POST",
        url: path,
        responseType: "json",
        data: payload
      }).catch((error) => {
        return error.response;
      })
    );
    return callback(response?.status, response?.data);
  }

  async put(path, payload, callback) {
    const response = await trackPromise(
      this.service.request({
        method: "PUT",
        url: path,
        responseType: "json",
        data: payload,
      }).catch((error) => {
        return error.response;
      })
    );
    return callback(response?.status, response?.data);
  }

  async delete(path, callback) {
    const response = await trackPromise(
      this.service.request({
        method: "DELETE",
        url: path,
        responseType: "json",
      }).catch((error) => {
        return error.response;
      })
    );
    return callback(response?.status, response?.data);
  }

  getDefaultErrorResponse() {
    return {
      isSuccess: false,
      errorMessage: "internal_exception",
      status: ApiOperationStatus.Exception
    }
  }
}
